import axios from 'axios'
import apiUtils from './apiUtils'
import moment from 'moment'
import Util from '@/util'

const apiParams = {
  baseURL: `${process.env.BASE_TV_API_URL}/`,
}

apiParams.withCredentials = false
apiParams.transformResponse = [(data) => apiUtils.checkResponse(data)]

apiParams.validateStatus = function (status) {
  window.vm.showSpinner = false

  if (status === 401 || status === 403) {
    window.vm.$store.dispatch('users/forceLogoutUser')
    window.vm.$router.push('/auth')
  }

  if (status == 404) {
    window.vm.$router.push('/404')
  }

  if (status >= 200 && status < 400) {
    return true
  }

  return false
}

const apiAxios = axios.create(apiParams)

apiAxios.interceptors.request.use((config) => {
  window.vm.showSnackbar = false

  var selected = JSON.parse(Util.atobUtf8(localStorage.getItem('selected_config')))
  if (selected && selected.AccountName) {
    config.headers.common['Authorization'] = `${apiUtils.getTradevineOAuthHeader(selected, apiUtils.uuidv4())}`
  }

  return config
})

apiAxios.interceptors.response.use((response) => {
  window.vm.showSpinner = false

  return response
})

export default {
  getApiParams() {
    return apiParams
  },
  getCollectionOrders() {
    var cutoff = new moment().subtract('minutes', 60)
    return apiAxios.get(`SalesOrder?shippingType=25001&modifiedFrom=${cutoff.format('YYYY-MM-DD HH:mm:ss')}`)
  },
}
